/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import NotoSansTC from "fonts/NotoSansTC-VariableFont_wght.ttf";
import NotoSansSC from "fonts/NotoSansSC-VariableFont_wght.ttf";
import Outfit from "fonts/Outfit-VariableFont_wght.ttf";
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

const globals = {
  "@font-face": [
    {
      fontFamily: "Noto Sans TC",
      src: `url(${NotoSansTC}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
    {
      // 2026-05-25 簡體中文字體（依語系切換）
      fontFamily: "Noto Sans SC",
      src: `url(${NotoSansSC}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Outfit",
      src: `url(${Outfit}) format("truetype")`,
      fontWeight: "100 900",
      fontDisplay: "swap",
    },
  ],
  // 2026-05-25 中文字體用 CSS 變數，依 body[data-lang] 切換（TC ↔ SC）
  //   英數一律 Outfit；中文：繁體 → Noto Sans TC、簡體 → Noto Sans SC
  ":root": {
    "--cjk-font": '"Noto Sans TC"',
  },
  'body[data-lang="zh-CN"]': {
    "--cjk-font": '"Noto Sans SC"',
  },
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  // 需要顯示底線的連結，加上 .auth-underline className 即可（覆寫上面的 !important）
  "a.auth-underline, a.auth-underline:link, a.auth-underline:visited": {
    textDecoration: "underline !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
